import { css } from '@emotion/css';

export const ratingLabelStyles = css`
  min-width: 5.6rem;
  overflow-wrap: anywhere;
`;
